// React Imports
import * as React from "react";
import {useDispatch, useSelector} from "react-redux";


// Mui Imports
import MenuItem from "@mui/material/MenuItem";
import {
    ListItemIcon,
    ListItemText,
    Tooltip
} from "@mui/material";


// App Imports

import Box from "@mui/material/Box";
import DriveFileMoveIcon from "@mui/icons-material/DriveFileMove";


// main function
export default function MoveContract({ onMenuClose, rowContractData }) {

    // ****************** BEGIN DISPATCH ****************************

    const dispatchData = useDispatch();

    // ****************** END DISPATCH ****************************



    return (

        <Box>
            {(rowContractData.contractLevel === "X") &&
                <MenuItem>
                        <ListItemIcon>
                            <DriveFileMoveIcon fontSize="small"/>
                        </ListItemIcon>
                        <ListItemText>Move</ListItemText>
                </MenuItem>
            }
        </Box>

    )

}
